import { clsx } from 'clsx'

import { useRouter } from '@tribeplatform/react-sdk'
import { useSpaceUtil } from '@tribeplatform/react-sdk/hooks'

import { PostHiddenIndicator } from '../../Post/PostHiddenIndicator.js'
import { PostLockedIndicator } from '../../Post/PostLockedIndicator.js'
import type { PostContext } from '../../Post/types.js'
import {
  CustomFieldViewProps,
  TitleSizes,
  getTitleClassName,
  TITLE_FIELD_KEY,
} from '../utils.js'

interface Props extends CustomFieldViewProps {
  titleSize?: TitleSizes
  context?: PostContext
}
export const TitleView = ({
  field,
  entity,
  value,
  titleSize = 'lg',
  context,
}: Props) => {
  const { generatePostPath } = useSpaceUtil()
  const { Link } = useRouter()
  const isHidden = entity?.isHidden
  const isLocked = entity?.locked

  if (context === 'post') {
    return (
      <h2 className={clsx('text-content', getTitleClassName(titleSize))}>
        {isHidden && <PostHiddenIndicator />}
        {isLocked && <PostLockedIndicator />}
        {value}
      </h2>
    )
  }

  if (field?.key === TITLE_FIELD_KEY) {
    return (
      <Link
        href={entity?.relativeUrl || generatePostPath(entity?.space, entity)}
        onClick={e => e.stopPropagation()}
      >
        <h2
          className={clsx(
            'text-content line-clamp-3',
            getTitleClassName(titleSize),
          )}
        >
          {isHidden && <PostHiddenIndicator />}
          {isLocked && <PostLockedIndicator />}
          {value}
        </h2>
      </Link>
    )
  }

  return (
    <Link
      href={entity?.relativeUrl || generatePostPath(entity?.space, entity)}
      onClick={e => e.stopPropagation()}
    >
      <h2 className={clsx('text-content block', getTitleClassName(titleSize))}>
        {value}
      </h2>
    </Link>
  )
}
